export enum ApiResource {
  Auth = 'auth',
  Users = 'users',
  Notams = 'notams',
  Companies = 'companies',
  AccessTimes = 'accesstimes',
  MapanyServers = 'mapanyservers',
  FeatureFlags = 'featureflags',
  Agreements = 'agreements',
  Access = 'access',
  C4Model = 'c4model',
}

export interface ApiData {
  data: any;
  errors?: any[];
}

export interface SignInRequest {
  username: string;
  password: string;
}

export interface SignInResponse {
  token: string;
  tokenExpiry: string;
  refreshToken: string;
  message: string;
}

export interface GetListRequestMain {
  sortName: string;
  sortAsc: boolean;
  limit: number;
  offset: number;
}

export interface FilterNotam{
  id?: string;
  body?: string;
  status?: string;
  log?: string;
  resultNotamsIds: string;
};

export interface FilterUser {
  id?: string;
  uuid?: string;
  username?: string;
  email?: string;
  tester?: string;
  companyAdmin?: string;
  superAdmin?: string;
  position?: string;
  companyId?: string;
  dsp?: string;
  multi?: string;
  firstname?: string;
  middlename?: string;
  lastname?: string;
  phone?: string;
  description?: string;
  personnelNumber?: string;
};

export interface FilterCompany {
  id?: string;
  uuid?: string;
  name?: string;
  fullname?: string;
  phone?: string;
  payment?: string;
  email?: string;
  supportEmail?: string;
  isAcceptingUsers?: string;
  hackAviaBriefingServer?: string;
  misc?: string;
  strictRights?: string;
};

export interface FilterStatistic {
  login?: string;
  userId?: string;
  companyId?: string;
  time?: string;
};

export interface FilterMapAni {
  id?: string;
  name?: string;
  companyId?: string;
  host?: string;
  key?: string;
  isEnabled?: string;
  hostName?: string;
};

export interface User {
  id: number;
  uuid: string;
  username: string;
  email: string;
  tester: boolean;
  companyAdmin: boolean;
  superAdmin: boolean;
  position: string;
  companyId: number;
  dsp: boolean;
  multi: boolean;
  firstname: string;
  middlename: string;
  lastname: string;
  phone: string;
  description: string;
  personnelNumber: string;
  deleted: boolean;
  enabled: boolean;
};

export interface UserInput {
  id: number;
  uuid: string;
  username: string;
  password: string;
  email: string;
  tester: boolean;
  superAdmin: boolean;
  position: string;
  companyId: number;
  dsp: boolean;
  multi: boolean;
  firstname: string;
  middlename: string;
  lastname: string;
  phone: string;
  description: string;
};

export interface Notam {
  id: number;
  body : string;
  status: string;
};

export interface NotamInput {
  id: number;
  body : string;
  status: string;
};

export interface Company {
  id: number;
  uuid: string;
  name: string;
  fullname: string;
  phone: string;
  payment: string;
  email: string;
  supportEmail: string;
  isAcceptingUsers: boolean;
  hackAviaBriefingServer: boolean;
  misc: string;
  strictRights: boolean;
}

export interface CompanyInput {
  id: number;
  uuid: string;
  name: string;
  fullname: string;
  phone: string;
  payment: string;
  email: string;
  supportEmail: string;
  isAcceptingUsers: boolean;
  hackAviaBriefingServer: boolean;
  misc: string;
  strictRights: boolean;
}

export interface Statistic {
  id: number;
  userId: number;
  companyId: number;
  time: string;
};

export interface Server {
  id: number;
  name: string;
  companyId: number;
  host: string;
  key: string;
  isEnabled: boolean;
  hostName: string;
};

export interface ServerInput {
  id: number;
  name: string;
  companyId: number;
  host: string;
  key: string;
  isEnabled: boolean;
  hostName: string;
};

export interface CustomData {
  uuid: string;
  name: string;
  expiresAt: string;
  usersLimit: number;
}

export interface MapBox {
  data: CustomData;
  type: string;
}

export interface DistrictSchema {
  data: CustomData;
  printLimit: number;
};

export interface AHSchema {
  data: DistrictSchema;
  type: string;
  flightRules: string;
  locationIndicatorIcao: string;
  iataCode: string;
};

export interface AccessList {
  navData: CustomData[];
  procedures: CustomData[];
  cartographyMap: CustomData[];
  mapBox: MapBox[];
  districtSchema: DistrictSchema[];
  ahSchema: AHSchema[];
};

export interface InputAccessListRemove {
  id: number;
  navData?: string[];
  procedures?: string[];
  cartographyMap?: string[];
  mapBox?: string[];
  districtSchema?: string[];
  ahSchema?: string[];
};

export interface InputAccessListCreate {
  accessList: InputAccessListRemove;
  date?: string;
  printLimits?: number;
  userLimits?: number;
};

export interface InputAccessListRemove {
  id: number;
  navData?: string[];
  procedures?: string[];
  cartographyMap?: string[];
  mapBox?: string[];
  districtSchema?: string[];
  ahSchema?: string[];
};

export interface FunctionalityResponse {
  name?: string;
  expiresAt?: string;
  usersLimit?: string;
  devicesLimit?: string;
};

export interface Functionality {
  name: string;
  expiresAt: string;
  usersLimit: number;
  devicesLimit: number;
};

export interface FunctionalityList {
  id: number;
  list: Functionality[];
}

export interface InputFunctionality {
  name: string;
  expiresAt: string;
  usersLimit: number;
  devicesLimit: number;
};

export interface InputFunctionalityList {
  id: number;
  list: InputFunctionality[];
}

export interface InputFunctionalityRemove {
  id: number;
  functionalityList: string[];
}

export interface AdminTokenRequest {
  username: string;
  type: string;
  token: string;
}

export interface AdminMailRequest {
  id: number;
  content: string;
  test?: string;
}

export interface AdminMailAviatorAccessRequest {
  accesses: number[];
}

export interface FeatureFlag {
  id: number;
  internalName: string;
  displayName: string;
};

export interface FeatureFlagInput {
  id: number;
  internalName: string;
  displayName: string;
  enableDatetime: string;
  createdAt: string;
  updatedAt: string;
};

export interface Agreement {
  id: number;
  agreementUserId: number;
  agreementUserUpdatedAt: string;
  agreementUserUpdatedBy: string;
  agreementUserText: string;
  agreementPrivacyId: number;
  agreementPrivacyUpdatedAt: string;
  agreementPrivacyUpdatedBy: string;
  agreementPrivacyText: string;
};

export interface AgreementInput {
  agreementUserText: string;
  agreementPrivacyText: string;
};

const callBai = async (
  route: string,
  method: string,
  body: any,
  params?: AbortSignal
) => {
  const signal = params;

  const headers = {
  } as any;
  if (
    (localStorage.getItem('token') || '').length > 0
  ) {
    headers['Authorization'] = 'Bearer '.concat(
      (localStorage.getItem('token') || '')
    );
    headers['idempotent-key'] = localStorage.getItem('idempotent-key');
  }
  headers['Content-Type'] = 'application/json';

  var host = process.env.REACT_APP_API_HOST;
  if(!host){
    host = window.location.origin;
  }
  const res = await fetch(`${host}/api/${route}`, {
    method: method,
    headers: headers,
    body: JSON.stringify(body),
    signal
  });
  if (res.status === 401||res.status === 403) {
    logout();
    window.location.reload();
  }
  if(res.status === 503){
    throw new Error('internal server error, please try again later');
  }
  const data = await res.json() as any;
  if(res.status === 200){
    return data;
  }
  if(res.status === 400||res.status === 474){
    throw new Error('invalid form data, details: '+data.message);
  }
  if(res.status === 500){
    throw new Error('internal server error, details: '+data.message);
  }
  console.log('response code',res.status,'response data',data)
  throw new Error(data.message);
  // return {error: data};
};

const signin = async (
  signInRequest: SignInRequest,
  signal?: AbortSignal
) => {
  const data = await callBai(
    'auth/check',
    'POST',
    signInRequest,
    signal
  );
  return data;
};

const login = async (
  signInRequest: SignInRequest,
  signal?: AbortSignal
) => {
  const signInResponse = await signin(
    signInRequest,
    signal
  );
  localStorage.setItem('token', signInResponse.token);
  localStorage.setItem('idempotent-key', uuidv4());
  localStorage.setItem('tokenExpiry', signInResponse.tokenExpiry);
  localStorage.setItem('refreshToken', signInResponse.refreshToken);
};
const uuidv4 =()=> {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    // eslint-disable-next-line
    var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
});
}
const logout = async (
) => {
  localStorage.removeItem('token');
  localStorage.removeItem('idempotent-key');
  localStorage.removeItem('tokenExpiry');
  localStorage.removeItem('refreshToken');
};

const checkAuth = () => {
  return !!localStorage.getItem('token');
};

const usersGetList = async (
  request: GetListRequestMain,
  filter: FilterUser,
  signal?: AbortSignal
) => {
  const query = {
    requestList:request,
    filter: filter
  };

  const data = await callBai(
    'new-admin/user/list',
    'POST',
    query,
    signal
  );
  const users = data.users as User[]
    || [];
  const count = data.count ? +data.count : 0;
  return {
    users,
    count
  };
};

const usersGetMany = async (
  ids: number[],
  signal?: AbortSignal
) => {
  const query = {
    ids: ids
  };

  const data = await callBai(
    'new-admin/user/many',
    'POST',
    query,
    signal
  );
  const users = data.users as User[]
    || [];
  return users;
};

const usersGetOne = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/user/one',
    'POST',
    query,
    signal
  );
  const user = data as User;
  return user;
};

const usersUpdate = async (
  user: UserInput,
  signal?: AbortSignal
) => {
  const query = user;

  const data = await callBai(
    'new-admin/user',
    'PUT',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

const usersCreate = async (
  user: UserInput,
  signal?: AbortSignal
) => {
  const query = user;

  const data = await callBai(
    'new-admin/user',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;
  const id = data.id as number;

  return success ?
    id : 0;
};

const usersDelete = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/user',
    'DELETE',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

const notamsGetList = async (
  request: GetListRequestMain,
  filter: FilterNotam,
  signal?: AbortSignal
) => {
  const query = {
    requestList:request,
    filter: filter
  };

  const data = await callBai(
    'new-admin/notam/list',
    'POST',
    query,
    signal
  );
  const notams = data.notams as Notam[]
    || [];
  const count = data.count ? +data.count : 0;
  return {
    notams,
    count
  };
};const notamsGetMany = async (
  ids: number[],
  signal?: AbortSignal
) => {
  const query = {
    ids: ids
  };

  const data = await callBai(
    'new-admin/notam/many',
    'POST',
    query,
    signal
  );
  const notams = data.notams as Notam[]
    || [];
  return notams;
};

const notamsGetOne = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/notam/one',
    'POST',
    query,
    signal
  );
  const notam = data as Notam;
  return notam;
};

const notamsUpdate = async (
  notam: NotamInput,
  signal?: AbortSignal
) => {
  const query = notam;

  const data = await callBai(
    'new-admin/notam',
    'PUT',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

const notamsCreate = async (
  notam: NotamInput,
  signal?: AbortSignal
) => {
  const query = notam;

  const data = await callBai(
    'new-admin/notam',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;
  const id = data.id as number;

  return success ?
    id : 0;
};

const notamsDelete = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/notam',
    'DELETE',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

const reparseNotam = async (
  request: NotamInput,
  signal?: AbortSignal
) => {
  const data = await callBai(
    `new-admin/notam/parse`,
    'POST',
    {
      body: request.body
    },
    signal
  );
  return data;
};

const companiesGetList = async (
  request: GetListRequestMain,
  filter: FilterCompany,
  signal?: AbortSignal
) => {
  const query = {
    requestList:request,
    filter: filter
  };

  const data = await callBai(
    'new-admin/company/list',
    'POST',
    query,
    signal
  );
  const companies = data.companies as Company[]
    || [];
  const count = data.count ? +data.count : 0;
  return {
    companies,
    count
  };
};

const companiesGetMany = async (
  ids: number[],
  signal?: AbortSignal
) => {
  const query = {
    ids: ids
  };

  const data = await callBai(
    'new-admin/company/many',
    'POST',
    query,
    signal
  );
  const companies = data.companies as Company[]
    || [];
  return companies;
};

const companiesGetOne = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/company/one',
    'POST',
    query,
    signal
  );
  const company = data as Company;
  return company;
};

const companiesUpdate = async (
  company: CompanyInput,
  signal?: AbortSignal
) => {
  const query = company;

  const data = await callBai(
    'new-admin/company',
    'PUT',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

const companiesCreate = async (
  company: CompanyInput,
  signal?: AbortSignal
) => {
  const query = company;

  const data = await callBai(
    'new-admin/company',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;
  const id = data.id as number;

  return success ?
    id : 0;
};

const companiesDelete = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/company',
    'DELETE',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};


const accessTimesGetList = async (
  request: GetListRequestMain,
  filter: FilterStatistic,
  signal?: AbortSignal
) => {
  const query = {
    requestList:request,
    filter: filter
  };

  const data = await callBai(
    'new-admin/statistic/list',
    'POST',
    query,
    signal
  );
  const accessTimes = data.statistics as Statistic[]
    || [];
  const count = data.count ? +data.count : 0;
  return {
    accessTimes,
    count
  };
};

const mapanyServersGetList = async (
  request: GetListRequestMain,
  filter: FilterMapAni,
  signal?: AbortSignal
) => {
  const query = {
    requestList:request,
    filter: filter
  };

  const data = await callBai(
    'new-admin/mapani/list',
    'POST',
    query,
    signal
  );
  const mapanyServers = data.servers as Server[] || [];
  const count = data.count ? +data.count : 0;
  return {
    mapanyServers,
    count
  };
};

const mapanyServersGetOne = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/mapani/one',
    'POST',
    query,
    signal
  );
  const mapanyServer = data as Server;
  return mapanyServer;
};

const mapanyServersUpdate = async (
  mapanyServer: ServerInput,
  signal?: AbortSignal
) => {
  const query = mapanyServer;

  const data = await callBai(
    'new-admin/mapani',
    'PUT',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

const mapanyServersCreate = async (
  mapanyServer: ServerInput,
  signal?: AbortSignal
) => {
  const query = mapanyServer;

  const data = await callBai(
    'new-admin/mapani',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;
  const id = data.id as number;

  return success ?
    id : 0;
};

const mapanyServersDelete = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/mapani',
    'DELETE',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};



const agreementsGetList = async (
  request: GetListRequestMain,
  filter: FilterMapAni,
  signal?: AbortSignal
) => {
  const query = {
    requestList:request,
    filter: filter
  };

  const data = await callBai(
    'new-admin/agreement/list', 
    'POST',
    query,
    signal
  );
  const agreements = data.agreements as Agreement[] || []; 
  const count = data.count ? +data.count : 0;
  return {
    agreements,
    count
  };
};

const agreementsGetOne = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };
  const data = await callBai(
    'new-admin/agreement/one',
    'POST',
    query,
    signal
  );
  const item = data as Agreement;
  return item;
};

const agreementsUpdate = async (
  item: AgreementInput,
  signal?: AbortSignal
) => {
  var query = item;
  query.agreementUserText = localStorage.getItem('userAgreementSaved')||'';
  query.agreementPrivacyText = localStorage.getItem('privacyAgreementSaved')||'';

  const data = await callBai(
    'new-admin/agreement',
    'PUT',
    query,
    signal
  );
  const success = data.success as boolean;

  return success;
};

const featureFlagsGetList = async (
  request: GetListRequestMain,
  filter: FilterMapAni,
  signal?: AbortSignal
) => {
  const query = {
    requestList:request,
    filter: filter
  };

  const data = await callBai(
    'new-admin/feature-flag/list',
    'POST',
    query,
    signal
  );
  const featureFlags = data.featureFlags as FeatureFlag[] || [];
  const count = data.count ? +data.count : 0;
  return {
    featureFlags,
    count
  };
};

const featureFlagsGetOne = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/feature-flag/one',
    'POST',
    query,
    signal
  );
  const item = data as FeatureFlag;
  return item;
};

const featureFlagsUpdate = async (
  item: FeatureFlagInput,
  signal?: AbortSignal
) => {
  const query = item;
  query.createdAt = query.enableDatetime
  query.updatedAt = query.enableDatetime

  const data = await callBai(
    'new-admin/feature-flag',
    'PUT',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

const featureFlagsCreate = async (
  item: FeatureFlagInput,
  signal?: AbortSignal
) => {
  const query = item;
  query.createdAt = query.enableDatetime
  query.updatedAt = query.enableDatetime

  const data = await callBai(
    'new-admin/feature-flag',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;
  const id = data.id as number;

  return success ?
    id : 0;
};

const featureFlagsDelete = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/feature-flag',
    'DELETE',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

const getAccessListUser = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/user/access/list',
    'POST',
    query,
    signal
  );
  const accessList = data as AccessList;
  return accessList;
};

const createAccessUser = async (
  request: InputAccessListCreate,
  signal?: AbortSignal
) => {
  const query = request;

  const data = await callBai(
    'new-admin/user/access',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;

  return success;
};

const removeAccessUser = async (
  request: InputAccessListRemove,
  signal?: AbortSignal
) => {
  const query = request;

  const data = await callBai(
    'new-admin/user/access',
    'DELETE',
    query,
    signal
  );
  const success = data.success as boolean;

  return success;
};

const getFunctionalityListUser = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/user/functionality/list',
    'POST',
    query,
    signal
  );
  const list = (data.list || []) as FunctionalityResponse[];

  const fucntionalityList = list.map(response => ({
    name: response.name || '',
    expiresAt: response.expiresAt || '',
    usersLimit: response.usersLimit ? +response.usersLimit : 0,
    devicesLimit: response.devicesLimit ? +response.devicesLimit : 0,
  } as Functionality));
  return fucntionalityList;
};

const createFunctionalityUser = async (
  request: InputFunctionalityList,
  signal?: AbortSignal
) => {
  const query = request;

  const data = await callBai(
    'new-admin/user/functionality',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;

  const aviatorAccessesIds = data.ids as number[] | null;
  if (aviatorAccessesIds && aviatorAccessesIds.length) {
    adminMailAviatorAccess(
      {
        accesses: aviatorAccessesIds
      },
      signal
    )
  }
  return success;
};

const removeFunctionalityUser = async (
  request: InputFunctionalityRemove,
  signal?: AbortSignal
) => {
  const query = request;

  const data = await callBai(
    'new-admin/user/functionality',
    'DELETE',
    query,
    signal
  );
  const success = data.success as boolean;

  return success;
};

const getAccessListCompany = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/company/access/list',
    'POST',
    query,
    signal
  );
  const accessList = data as AccessList;
  return accessList;
};

const createAccessCompany = async (
  request: InputAccessListCreate,
  signal?: AbortSignal
) => {
  const query = request;

  const data = await callBai(
    'new-admin/company/access',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;

  return success;
};

const removeAccessCompany = async (
  request: InputAccessListRemove,
  signal?: AbortSignal
) => {
  const query = request;

  const data = await callBai(
    'new-admin/company/access',
    'DELETE',
    query,
    signal
  );
  const success = data.success as boolean;

  return success;
};

const getFunctionalityListCompany = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/company/functionality/list',
    'POST',
    query,
    signal
  );
  
  const list = (data.list || []) as FunctionalityResponse[];

  const fucntionalityList = list.map(response => ({
    name: response.name || '',
    expiresAt: response.expiresAt || '',
    usersLimit: response.usersLimit ? +response.usersLimit : 0,
    devicesLimit: response.devicesLimit ? +response.devicesLimit : 0,
  } as Functionality));
  return fucntionalityList;
};

const createFunctionalityCompany = async (
  request: InputFunctionalityList,
  signal?: AbortSignal
) => {
  const query = request;

  const data = await callBai(
    'new-admin/company/functionality',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;

  const aviatorAccessesIds = data.ids as number[] | null;
  if (aviatorAccessesIds && aviatorAccessesIds.length) {
    adminMailAviatorAccess(
      {
        accesses: aviatorAccessesIds
      },
      signal
    )
  }

  return success;
};

const removeFunctionalityCompany = async (
  request: InputFunctionalityRemove,
  signal?: AbortSignal
) => {
  const query = {
    id: request.id,
    functionalityList: request.functionalityList
  };

  const data = await callBai(
    'new-admin/company/functionality',
    'DELETE',
    query,
    signal
  );
  const success = data.success as boolean;

  return success;
};

const adminToken = async (
  request: AdminTokenRequest,
  signal?: AbortSignal
) => {
  const data = await callBai(
    `admin/token/${request.username}`,
    'POST',
    {
      type: request.type,
      token: request.token
    },
    signal
  );
  return data;
};

const adminMail = async (
  request: AdminMailRequest,
  signal?: AbortSignal
) => {
  const data = await callBai(
    `admin/mail/company/${request.id}`,
    'POST',
    {
      content: request.content,
      test: request.test
    },
    signal
  );
  return data;
};

const adminMailAviatorAccess = async (
  request: AdminMailAviatorAccessRequest,
  signal?: AbortSignal
) => {
  const data = await callBai(
    `admin/mail/aviator`,
    'POST',
    {
      accesses: request.accesses
    },
    signal
  );
  return data;
};

const isCompanyAdmin = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/company/isadmin',
    'POST',
    query,
    signal
  );
  const isCompanyAdmin = data.success as boolean;
  return isCompanyAdmin;
};

const setCompanyAdmin = async (
  id: number,
  isCompanyAdmin: boolean,
  signal?: AbortSignal
) => {
  const query = {
    id: id,
    success: isCompanyAdmin
  };

  const data = await callBai(
    'new-admin/user/setcompanyadmin',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

const restoreUser = async (
  id: number,
  signal?: AbortSignal
) => {
  const query = {
    id: id
  };

  const data = await callBai(
    'new-admin/user/recovery',
    'POST',
    query,
    signal
  );
  const success = data.success as boolean;
  return success;
};

export {
  login,
  logout,
  checkAuth,
  usersGetList,
  usersGetMany,
  usersGetOne,
  usersUpdate,
  usersCreate,
  usersDelete,
  notamsUpdate,
  notamsCreate,
  notamsDelete,
  notamsGetOne,
  notamsGetMany,
  notamsGetList,
  reparseNotam,
  companiesGetList,
  companiesGetMany,
  companiesGetOne,
  companiesUpdate,
  companiesCreate,
  companiesDelete,
  accessTimesGetList,
  mapanyServersGetList,
  mapanyServersGetOne,
  mapanyServersUpdate,
  mapanyServersCreate,
  mapanyServersDelete,
  agreementsGetList,
  agreementsGetOne,
  agreementsUpdate,
  featureFlagsGetList,
  featureFlagsGetOne,
  featureFlagsUpdate,
  featureFlagsCreate,
  featureFlagsDelete,
  getAccessListUser,
  createAccessUser,
  removeAccessUser,
  getFunctionalityListUser,
  createFunctionalityUser,
  removeFunctionalityUser,
  getAccessListCompany,
  createAccessCompany,
  removeAccessCompany,
  getFunctionalityListCompany,
  createFunctionalityCompany,
  removeFunctionalityCompany,
  adminToken,
  adminMail,
  isCompanyAdmin,
  setCompanyAdmin,
  restoreUser
};
